import { createRouter, createWebHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getEnrollToken, getToken, isAdmin } from '@/utils/auth'

const routes = [
    {
        path: '/',
        name: 'Home',
        redirect: '/semesters'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/LoginView.vue'),
        meta: { title: '登录', public: true, standalone: true }
    },
    {
        path: '/enroll/login',
        name: 'EnrollLogin',
        component: () => import('../views/EnrollStudentLogin.vue'),
        meta: { title: '自主招生登录', public: true, standalone: true }
    },
    {
        path: '/enroll/register',
        name: 'EnrollRegister',
        component: () => import('../views/EnrollStudentRegister.vue'),
        meta: { title: '自主招生注册', public: true, standalone: true }
    },
    {
        path: '/enroll',
        component: () => import('../views/EnrollLayout.vue'),
        meta: { title: '自主招生填报', standalone: true, requiresEnrollAuth: true },
        children: [
            {
                path: '',
                redirect: '/enroll/form'
            },
            {
                path: 'form',
                name: 'EnrollForm',
                component: () => import('../views/EnrollStudentForm.vue'),
                meta: { title: '自主招生填报', standalone: true, requiresEnrollAuth: true }
            },
            {
                path: 'status',
                name: 'EnrollStatus',
                component: () => import('../views/EnrollStudentStatus.vue'),
                meta: { title: '审核进度', standalone: true, requiresEnrollAuth: true }
            }
        ]
    },
    {
        path: '/semesters',
        name: 'Semesters',
        component: () => import('../views/SemesterManagement.vue'),
        meta: { title: '学期管理' }
    },
    {
        path: '/teachers',
        name: 'Teachers',
        component: () => import('../views/TeacherManagement.vue'),
        meta: { title: '教师管理' }
    },
    {
        path: '/exams',
        name: 'Exams',
        component: () => import('../views/ExamManagement.vue'),
        meta: { title: '考试管理' }
    },
    {
        path: '/schedules/:examId',
        name: 'Schedules',
        component: () => import('../views/ScheduleManagement.vue'),
        meta: { title: '监考排程' },
        props: true
    },
    {
        path: '/statistics',
        name: 'Statistics',
        component: () => import('../views/WorkloadStats.vue'),
        meta: { title: '工作量统计' }
    },
    {
        path: '/grades',
        name: 'Grades',
        component: () => import('../views/GradeManagement.vue'),
        meta: { title: '成绩管理' }
    },
    {
        path: '/grade-analysis',
        name: 'GradeAnalysis',
        component: () => import('../views/GradeAnalysis.vue'),
        meta: { title: '成绩分析' }
    },
    {
        path: '/key-class-analysis',
        name: 'KeyClassAnalysis',
        component: () => import('../views/KeyClassAnalysis.vue'),
        meta: { title: '重点班分析' }
    },
    {
        path: '/students',
        name: 'Students',
        component: () => import('../views/StudentManagement.vue'),
        meta: { title: '学生管理' }
    },
    {
        path: '/users',
        name: 'Users',
        component: () => import('../views/UserManagement.vue'),
        meta: { title: '用户管理', requiresAdmin: true }
    },
    {
        path: '/enroll/reviews',
        name: 'EnrollReviews',
        component: () => import('../views/EnrollReviewManagement.vue'),
        meta: { title: '自主招生审核' }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    const adminToken = getToken()
    const enrollToken = getEnrollToken()
    const isPublic = !!to.meta.public

    if (to.meta.requiresEnrollAuth && !enrollToken) {
        next('/enroll/login')
        return
    }

    if (!isPublic && !to.meta.requiresEnrollAuth && !adminToken) {
        next('/login')
        return
    }

    if (to.path === '/login' && adminToken) {
        next('/semesters')
        return
    }

    if ((to.path === '/enroll/login' || to.path === '/enroll/register') && enrollToken) {
        next('/enroll/form')
        return
    }

    if (to.meta.requiresAdmin && !isAdmin()) {
        ElMessage.error('仅管理员可访问该页面')
        next(from.path && from.path !== '/login' ? from.path : '/semesters')
        return
    }

    document.title = to.meta.title ? `${to.meta.title} - 智能教务考务系统` : '智能教务考务系统'
    next()
})

export default router
